import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import ApiService from '../../../services/apiService';
import { toast } from 'react-toastify';
import { RxCross1 } from 'react-icons/rx';
import { useSelector, useDispatch } from 'react-redux';
import { setRows, addRow, removeRow, removeSingleRow, updateRow, clearRows } from '../../../../Redux/actions/rowActions';
import { IoAddSharp } from 'react-icons/io5';
import { BarLoader } from 'react-spinners';
import AsyncSelect from 'react-select/async';
import {
  PO_ITEM_COL,
  poCompactSelectStyles,
  getDefaultVatOption,
  resolveRowVat,
  resolveVatForItem,
  getVatSelectValue,
  mapVatSelectOptions,
} from '../poItemGridColumns';
import Tooltip from '../../purchaseRequisition/tooltip';

const ItemGridTwo = ({
  apiData,
  onRequisitionData,
  setLoader,
  loder,
  itemData,
  itemList,
  selectedCheck,
  handleVatChange,
  isDiscountPercentage,
  currencyPrecision,
  setOverallDiscount, grandTotal, setVatAmount, vatAmount,
  overallDiscount, setDiscountAmount, discountAmount, setGrandTotal,
  currencyCode, exchangeRate
}) => {
  const rows = useSelector((state) => state.rows.rows);
  const [itemOptions, setItemOptions] = useState([]);
  const [descriptionOptions, setDescriptionOptions] = useState([]);
  const [vat, setvat] = useState([]);
  const dispatch = useDispatch();
  const apiService = new ApiService();
  const [overallDiscountAmount, setOverallDiscountAmount] = useState(); // Amount
  const [discountInputType, setDiscountInputType] = useState("");

  const [page, setPage] = useState(1);
  const [desPage, setDecPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loader, setLoaders] = useState(false);

  const [columnWidths, setColumnWidths] = useState({
    remove: 40,
    srNo: 80,
    itemNo: 150,
    description: 300,
    specification: 150,
    qty: 100,
    unitPrice: 120,
    discount: 120,
    calculatedAmount: 180,
    vat: 100,
    vatAmount: 160,
    amount: 140,
    inventoryQty: 140,
    lastPurchasePrice: 180
  });
  const calculatedTotal = rows.reduce((sum, row) => {
    const amount = parseFloat(row?.amount) || 0;
    const vatAmount = parseFloat(row?.vatAmount) || 0;
    const discount = parseFloat(row?.discount) || 0;

    let final = overallDiscount === 0 || overallDiscount === "0.000" ? ((amount + discount) - vatAmount) : (amount - vatAmount)
    return sum + (final);
  }, 0);
  const totalItemDiscount = rows.reduce((sum, row) => { return sum + Number(row?.discount || 0); }, 0);

  const subtotalAfterItemDiscount = calculatedTotal - totalItemDiscount;

  // useEffect(() => {
  //   if (rows[0]?.ItemNo) {
  //     updatevat();
  //   }
  // }, [selectedCheck]);
  // Replace the existing useEffects in ItemGrid with these:

  // Preserve the user-entered price and recalculate the active unit price
  // whenever the selected currency or exchange rate changes.
  useEffect(() => {
    const rate = Number(exchangeRate) > 0 ? Number(exchangeRate) : 1;
    if (!rows?.length) return;

    let needsUpdate = false;
    const updatedRows = rows.map((row) => {
      if (row?.realUnitPrice === undefined || row?.realUnitPrice === null || row?.realUnitPrice === '') return row;
      const unitPrice = Number(row.realUnitPrice || 0) * rate;
      if (Math.abs(Number(row.baseAmount || 0) - unitPrice) > 0.000001) needsUpdate = true;
      const qty = Number(row.qty || 0);
      const discount = Number(row.discount || 0);
      const vatRate = Number(row.vat || 0);
      const afterDiscount = (qty * unitPrice) - discount;
      const vatAmount = (afterDiscount * vatRate) / 100;
      return {
        ...row,
        baseAmount: unitPrice,
        calculatedAmount: afterDiscount?.toFixed(currencyPrecision || 3),
        discountAmount: afterDiscount?.toFixed(currencyPrecision || 3),
        vatAmount: vatAmount?.toFixed(currencyPrecision || 3),
        amount: (afterDiscount + vatAmount)?.toFixed(currencyPrecision || 3),
      };
    });
    if (!needsUpdate) return;
    dispatch(setRows(updatedRows));
    onRequisitionData(updatedRows);
  }, [currencyCode, exchangeRate]);

  useEffect(() => {
    fetchItemNo('', 1);
    fetchItemDesc('', 1);
    getVat();
  }, []);

  // Clear rows when itemData changes (important for dropdown changes)
  useEffect(() => {
    if (itemData?.requisitionNo) {
      // Clear existing rows when new itemData comes in
      dispatch(clearRows());
      setRows([]);
    }
  }, [itemData?.requisitionNo]); // React to requisition number changes

  // Process items when all dependencies are ready
  useEffect(() => {
    if (itemData?.requisitionNo > 0) {
      getItems();
    }
  }, [itemData, isDiscountPercentage]); // Add all necessary dependencies

  useEffect(() => {
    if (itemList?.requisitionNo) {
      getItems();
    }
  }, [itemList?.requisitionNo]);

  useEffect(() => {
    const grossAmount = rows.reduce(
      (sum, row) => sum + Number(row?.amount || 0),
      0
    );

    let discountAmt;

    if (discountInputType === "amount") {
      discountAmt = Number(overallDiscountAmount || 0);
    } else if (discountInputType === "percentage") {
      discountAmt =
        (calculatedTotal * Number(overallDiscount || 0)) / 100;
    } else {
      discountAmt = totalItemDiscount;
    }

    const afterDiscount = calculatedTotal - (discountAmt);

    // ---------------- VAT Calculation ----------------

    let vatAmount = 0;
    if (rows.some((row) => row?.isVatManuallyEntered === true)) {
      vatAmount = rows.reduce((sum, row) => sum + Number(row?.vatAmount || 0), 0);
    } else if (rows.length === 1) {
      const vatRate = rows[0]?.vat;
      vatAmount = (afterDiscount * vatRate) / 100;


      // vatAmount = rows.reduce(
      //   (sum, row) => sum + Number(row?.vatAmount || 0),
      //   0
      // );
    } else {
      // Get unique VAT rates
      const uniqueVatRates = [
        ...new Set(rows.map((r) => Number(r?.vat || 0))),
      ];
      if (uniqueVatRates.length === 1) {
        // Same VAT on all rows
        const vatRate = uniqueVatRates[0];
        const vatAmoun = (afterDiscount * vatRate) / 100;
        vatAmount = Number(vatAmoun?.toFixed(currencyPrecision || 3))
      } else {
        // Different VAT rates
        vatAmount = rows.reduce(
          (sum, row) => sum + parseFloat(row?.vatAmount || 0),
          0
        );
      }
    }

    // -------------------------------------------------

    const grandTotal = afterDiscount + vatAmount;
    setDiscountAmount(Number(discountAmt?.toFixed(3)));
    setVatAmount(vatAmount);
    setGrandTotal(Number(grandTotal?.toFixed(3)));

    setOverallDiscountAmount(Number(discountAmt?.toFixed(3)));

  }, [
    rows,
    overallDiscount,
    overallDiscountAmount,
    discountInputType
  ]);
  const ResizableHeader = ({ column, children }) => {
    return (
      <th
        style={{
          width: `${columnWidths[column]}px`,
          minWidth: `${columnWidths[column]}px`,
          position: 'relative'
        }}
      >
        {children}

        <span
          className="resize-handle"
          onMouseDown={(e) => startResize(e, column)}
        />
      </th>
    );
  };
  const updatevat = async () => {
    try {
      let vatParam = `?toPurchase=true`;
      const vat = await apiService.getApiParamater('GET_INV_TAX', vatParam);
      setvat(vat.data.result);
      const updatedRows = rows.map((row) => ({ ...row }));
      const apiPromises = updatedRows.map(async (row, index) => {
        const { rate: vatRate, description: vatDescription } = resolveRowVat(vat.data.result, row?.vatDec);

        const gross = Number(row.qty || 0) * Number(row.baseAmount || 0);
        const discount = Number(row?.discount || 0);
        const afterDiscount = gross - discount;
        const vatAmount = afterDiscount * Number(vatRate || 0) / 100;
        const finalAmount = afterDiscount + vatAmount;
        updatedRows[index].calculatedAmount = gross?.toFixed(currencyPrecision || 3);
        updatedRows[index].discountAmount = afterDiscount;
        updatedRows[index].amount = finalAmount;
        updatedRows[index].vat = vatRate;
        updatedRows[index].vatDec = vatDescription;
        updatedRows[index].isVatManuallyEntered = false;
        updatedRows[index].vatAmount = vatAmount?.toFixed(currencyPrecision || 3);
      });
      await Promise.all(apiPromises);
      setRows(updatedRows);
      onRequisitionData(updatedRows);
      dispatch(setRows(updatedRows));
    } catch (error) {
      console.error('Error updating rows with new stock:', error);
    }
  };
  const getVat = async () => {
    let vatParam = `?toPurchase=true`;
    const vat = await apiService.getApiParamater('GET_INV_TAX', vatParam);
    setvat(vat.data.result);
  };
  const getItems = async () => {
    try {
      let vatParam = `?toPurchase=true`;
      const vat = await apiService.getApiParamater('GET_INV_TAX', vatParam);
      setvat(vat.data.result);
      if (itemData?.requisitionNo) {
        setLoader(true);
        let param = `?Id=${itemData?.requisitionNo}`;
        const response = await apiService.getApiParamater('GET_PR', param);
        const selectedPR = response?.data?.result[0];
        if (!selectedPR) {
          console.error('Selected PR not found');
          return;
        }
        const prDetails = selectedPR?.prDetails || [];
        const formattedRowsPromises = itemData?.items
          ?.map(async (detail, index) => {
            const params = new URLSearchParams();

            params.append('ItemNo', detail.itemCode || '');
            const respons = await apiService.getApiParamater('GET_ITEM_PACK', `?${params.toString()}`);
            let selecteditem = respons?.data?.result[0];
            const selectedItem = rows?.find((item) => item?.itemDescription === detail?.itemDescription);
            const selectedPritem = prDetails?.find((item) => item.itemCode === detail.itemCode && item.qty === detail.qty);
            const selectedVat = resolveVatForItem(vat.data.result, selecteditem?.vat);
            ;
            if (!selecteditem) {
              console.error(`Selected item with description ${detail?.itemDescription} not found`);
              return null;
            }
            const grossAmount = Number(detail.qty) * Number(detail.price);
            const itemDiscount = Number(selectedItem?.discount || 0);
            const afterDiscount = grossAmount - itemDiscount;
            const vatAmount = parseFloat(afterDiscount * Number(selectedVat?.rate || 0) / 100);
            const finalAmount = afterDiscount + vatAmount;
            debugger
            return {
              requisitionNo: itemData.requisitionNo || '',
              srno: index + 1,
              _rowId: createRowId(),
              rsrno: selectedPritem?.srno,
              ItemNo: detail.itemCode,
              itemDescription: detail?.itemDescription,
              qty: detail?.qty,
              stock: selecteditem.convToInvUOM * detail?.qty,
              baseQty: selecteditem.convToInvUOM,
              uom: detail?.uom,
              avgPrice: selecteditem?.avgPrice || 0,
              baseAmount: detail?.price?.toFixed(4) || 0,
              realUnitPrice: Number(detail?.price || 0),
              specification: selectedPritem ? selectedPritem?.specification : '',
              amount: finalAmount,
              vat: selectedVat?.rate ?? 0,
              vatDec: selectedVat?.description ?? '',
              vatAmount: vatAmount,
              discount: itemDiscount,
              calculatedAmount: afterDiscount?.toFixed(currencyPrecision || 3),
              discountAmount: afterDiscount?.toFixed(currencyPrecision || 3),
            };
          })
          .filter((row) => row !== null);
        const formattedRows = await Promise.all(formattedRowsPromises);
        if (formattedRows?.length > 0) {
          setLoader(false);
          setRows(formattedRows.reverse());


          onRequisitionData(formattedRows.reverse());
          dispatch(setRows(formattedRows.reverse()));
        }
      } else if (itemList?.requisitionNo) {
        setLoader(true);
        let itm = itemList;
        let param = `?Id=${itemList?.requisitionNo}`;
        const response = await apiService.getApiParamater('GET_PR', param);
        const selectedPR = response?.data?.result[0];
        if (!selectedPR) {
          console.error('Selected PR not found');
          return;
        }
        const prDetails = selectedPR?.prDetails || [];
        const params = new URLSearchParams();
        params.append("DocNo", itemList.requisitionNo);
        params.append("Action", "CheckItemsExitsInPOForPR");

        const apiResponse = await apiService.getApiParamater(
          "GET_REQ_COMMON",
          `?${params.toString()}`
        );
        let POItems = []
        if (apiResponse?.data?.result?.data?.length > 0) {
          POItems = apiResponse?.data?.result?.data
        } else {
          POItems = [apiResponse?.data?.result?.data]
        }
        const filteredItems = itm?.items?.filter(detail => {
          return !POItems.some(poItem =>
            Number(poItem.SRNO) === Number(detail.srno) &&
            poItem.ItemCode === detail.itemCode &&
            poItem.ItemDescription === detail.itemDescription
          );
        });
        const formattedRowsPromises = filteredItems
          ?.map(async (detail, index) => {
            const params = new URLSearchParams();
            params.append('ItemNo', detail.itemCode || '');
            const response = await apiService.getApiParamater('GET_ITEM_PACK', `?${params.toString()}`);
            let selecteditem = response?.data?.result[0];
            const selectedItem = rows?.find((item) => item?.itemDescription === detail?.itemDescription);
            const selectedPritem = prDetails?.find((item) => item.itemCode === detail.itemCode && item.qty === detail.qty && item.srno === detail.srno && item.specification === detail.specification);
            const selectedVat = resolveVatForItem(vat.data.result, selecteditem?.vat);
            debugger
            return {
              requisitionNo: itemList.requisitionNo || '',
              srno: detail?.srno,
              _rowId: createRowId(),
              rsrno: selectedPritem?.srno,
              ItemNo: detail.itemCode,
              itemDescription: detail?.itemDescription,
              qty: detail?.qty,
              stock: selecteditem.convToInvUOM * detail?.qty,
              baseQty: selecteditem.convToInvUOM,
              avgPrice: selecteditem?.avgPrice || 0,
              uom: detail?.uom,
              baseAmount: 0,
              specification: detail ? detail?.specification : '',
              amount: 0,
              vat: selectedVat?.rate ?? 0,
              vatDec: selectedVat?.description ?? '',
              vatAmount: 0,
              discount: 0,
              calculatedAmount: 0,
              discountAmount: 0,
            };
          })
          .filter((row) => row !== null);
        const formattedRows = await Promise.all(formattedRowsPromises);
        if (formattedRows?.length > 0) {
          setLoader(false);


          setRows(formattedRows);
          onRequisitionData(formattedRows);
          dispatch(setRows(formattedRows));
        }
      }
    } catch (error) {
      setLoader(false);
      console.error('Error fetching items:', error);
    }
  };
  const fetchItemNo = async (inputValue = "", pageNumber = 1) => {
    if (loader) return;
    setLoaders(true);
    try {
      const apiService = new ApiService();
      const params = new URLSearchParams();
      params.append('PageNo', pageNumber || 1);
      params.append('PageSize', 20);
      params.append('SearchTerm', inputValue || '');
      const response = await apiService.getApiParamater('GET_ITEM_DROPDOWN', `?${params.toString()}`);
      const fetchedItems = response.data.result.map(item => ({
        label: item.itemNo,
        value: item,
      }));
      if (fetchedItems.length < 20) setHasMore(false);
      setItemOptions(prevAccounts => [...prevAccounts, ...fetchedItems]);
      setLoaders(false);
      return fetchedItems;
    } catch (error) {
      console.error("Error fetching account data:", error);
      setLoaders(false);
      return [];
    }
  };
  const fetchItemDesc = async (inputValue = "", pageNumber = 1) => {
    if (loader) return;
    setLoaders(true);
    try {
      const apiService = new ApiService();
      const params = new URLSearchParams();
      params.append('PageNo', pageNumber || 1);
      params.append('PageSize', 20);
      params.append('SearchTerm', inputValue || '');
      const response = await apiService.getApiParamater('GET_ITEM_DROPDOWN', `?${params.toString()}`);
      const fetchedItems = response.data.result.map(item => ({
        label: item?.itemDescription,
        value: item,
      }));
      if (fetchedItems.length < 20) setHasMore(false);
      setDescriptionOptions(prevAccounts => [...prevAccounts, ...fetchedItems]);
      setLoaders(false);
      return fetchedItems;
    } catch (error) {
      console.error("Error fetching account data:", error);
      setLoaders(false);
      return [];
    }
  };
  const loadOptions = async (inputValue, callback) => {
    if (inputValue.trim().length < 3) {
      callback([]);
      return;
    }

    const options = await fetchItemNo(inputValue, 1);
    callback(options);
  };
  const loadDescOptions = async (inputValue, callback) => {
    if (inputValue.trim().length < 3) {
      callback([]);
      return;
    }

    const options = await fetchItemDesc(inputValue, 1);
    callback(options);
  };
  const loadMoreOptions = async (inputValue = "") => {
    if (inputValue.trim().length < 3 || !hasMore || loader) return;

    setPage(prevPage => prevPage + 1);
    await fetchItemNo(inputValue, page + 1);
  };
  const loadMoreDescOptions = async (inputValue = "") => {
    if (inputValue.trim().length < 3 || !hasMore || loader) return;

    setDecPage(prevPage => prevPage + 1);
    await fetchItemDesc(inputValue, desPage + 1);
  };
  const createRowId = () => {
    return `${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
  };
  const handleInputChange = async (rowId, fieldName, value) => {
    // ---------------------------------------------------------
    // IMPORTANT:
    // Never use table/display index to identify a row.
    // Always use the unique _rowId.
    // ---------------------------------------------------------

    const getCurrentRow = (currentRows) =>
      currentRows.find((row) => row?._rowId === rowId);

    // ---------------------------------------------------------
    // SPECIFICATION
    // ---------------------------------------------------------
    if (fieldName === "specification") {
      const updatedRows = rows.map((row) =>
        row?._rowId === rowId
          ? {
            ...row,
            specification: value,
          }
          : row
      );

      dispatch(setRows(updatedRows));
      onRequisitionData(updatedRows);

      return;
    }

    // ---------------------------------------------------------
    // Find current row BEFORE API call
    // ---------------------------------------------------------
    const currentRow = getCurrentRow(rows);

    if (!currentRow) {
      console.warn("Row not found:", rowId);
      return;
    }

    // ---------------------------------------------------------
    // DISCOUNT VALIDATION
    // ---------------------------------------------------------
    if (fieldName === "discount") {
      const grossAmount =
        Number(currentRow.qty || 0) *
        Number(currentRow.baseAmount || 0);

      const discount = Number(value || 0);

      if (Number(overallDiscount || 0) > 0) {
        toast.warning(
          "Overall discount already applied. Clear it first."
        );
        return;
      }

      if (discount > grossAmount) {
        toast.warning("Discount cannot exceed Amount.");
        return;
      }
    }

    // ---------------------------------------------------------
    // ITEM NO
    // ---------------------------------------------------------
    if (fieldName === "ItemNo") {
      try {
        const getunit = await apiService.getApiParamater(
          "GET_ITEM_PACK",
          `?ItemNo=${encodeURIComponent(value)}`
        );

        const selectedItem = getunit?.data?.result?.[0];

        if (selectedItem) {
          const selectedVat = resolveVatForItem(
            vat,
            selectedItem?.vat
          );

          const updatedRows = rows.map((row) => {
            if (row?._rowId !== rowId) {
              return row;
            }

            return {
              ...row,
              itemDescription: selectedItem?.itemDescription,
              ItemNo: selectedItem?.itemNo,
              requisitionNo: selectedItem?.itemDescription,
              uom: selectedItem?.baseUnit,
              specification: selectedItem?.specification,
              vatDec: selectedVat?.description ?? "",
              vat: selectedVat?.rate ?? 0,
              isVatManuallyEntered: false,
              stock: 0,
              discount: 0,
              baseAmount: 0,
              realUnitPrice: 0,
              avgPrice:
                selectedItem?.avgPrice?.toFixed(
                  currencyPrecision || 3
                ) || 0,
              baseQty: parseFloat(
                selectedItem?.convToInvUOM || 0
              ),
            };
          });

          dispatch(setRows(updatedRows));
          onRequisitionData(updatedRows);
        }

        return;
      } catch (error) {
        console.error("Error fetching item:", error);
        return;
      }
    }

    // ---------------------------------------------------------
    // ITEM DESCRIPTION
    // ---------------------------------------------------------
    if (fieldName === "itemDescription") {
      try {
        const getunit = await apiService.getApiParamater(
          "GET_ITEM_PACK",
          `?ItemDescription=${encodeURIComponent(value)}`
        );

        const selectedItem = getunit?.data?.result?.[0];

        if (selectedItem) {
          const selectedVat = resolveVatForItem(
            vat,
            selectedItem?.vat
          );

          const updatedRows = rows.map((row) => {
            if (row?._rowId !== rowId) {
              return row;
            }

            return {
              ...row,
              specification: selectedItem?.specification,
              recordId: selectedItem?.itemNo,
              itemDescription: selectedItem?.itemDescription,
              ItemNo: selectedItem?.itemNo,
              discount: 0,
              stock: 0,
              uom: selectedItem?.baseUnit,
              baseQty: parseFloat(
                selectedItem?.convToInvUOM || 0
              ),
              vatDec: selectedVat?.description ?? "",
              vat: selectedVat?.rate ?? 0,
              isVatManuallyEntered: false,
              baseAmount: 0,
              realUnitPrice: 0,
              avgPrice:
                selectedItem?.avgPrice?.toFixed(
                  currencyPrecision || 3
                ) || 0,
            };
          });

          dispatch(setRows(updatedRows));
          onRequisitionData(updatedRows);
        }

        return;
      } catch (error) {
        console.error("Error fetching item description:", error);
        return;
      }
    }

    // ---------------------------------------------------------
    // QTY / PRICE / DISCOUNT / VAT
    // ---------------------------------------------------------
    const updatedRows = rows.map((row) => {
      if (row?._rowId !== rowId) {
        return row;
      }

      const manuallyEnteredVatAmount = row?.vatAmount;
      const updatedRow = {
        ...row,
      };

      // =======================================================
      // QTY
      // =======================================================
      if (fieldName === "qty") {
        const quantity = parseFloat(value) || 0;

        const convrate = Number(row?.baseQty || 0);

        const { rate: vatRate } = resolveRowVat(
          vat,
          row?.vatDec
        );

        const discount = Number(row?.discount || 0);

        const unitPrice = Number(row?.baseAmount || 0);

        const grossAmount = quantity * unitPrice;

        const afterDiscount =
          grossAmount - discount;

        const vatAmount =
          (afterDiscount * Number(vatRate || 0)) / 100;

        const finalAmount =
          afterDiscount + vatAmount;

        updatedRow.qty = quantity;
        updatedRow.baseAmount = unitPrice;
        updatedRow.baseQty = convrate;

        updatedRow.stock =
          convrate * quantity || 0;

        updatedRow.calculatedAmount =
          afterDiscount?.toFixed(
            currencyPrecision || 3
          );

        updatedRow.discountAmount =
          afterDiscount?.toFixed(
            currencyPrecision || 3
          );

        updatedRow.vatAmount =
          vatAmount?.toFixed(
            currencyPrecision || 3
          );

        updatedRow.amount =
          finalAmount?.toFixed(
            currencyPrecision || 3
          );
      }

      // =======================================================
      // DISCOUNT
      // =======================================================
      if (fieldName === "discount") {
        const discount =
          parseFloat(value) || 0;

        const unitPrice =
          Number(row?.baseAmount || 0);

        const quantity =
          Number(row?.qty || 0);

        const grossAmount =
          quantity * unitPrice;

        const afterDiscount =
          grossAmount - discount;

        const vatRate =
          Number(row?.vat || 0);

        const vatAmount =
          (afterDiscount * vatRate) / 100;

        const finalAmount =
          afterDiscount + vatAmount;

        updatedRow.discount = discount;

        updatedRow.calculatedAmount = afterDiscount?.toFixed(currencyPrecision || 3);

        updatedRow.discountAmount = afterDiscount?.toFixed(currencyPrecision || 3);

        updatedRow.vatAmount =
          vatAmount?.toFixed(
            currencyPrecision || 3
          );

        updatedRow.amount =
          finalAmount;
      }

      // =======================================================
      // UNIT PRICE
      // =======================================================
      if (fieldName === "baseAmount") {
        // Manual edits are already the value the user wants in the grid.
        // Do not apply the exchange rate on every keystroke; conversion is
        // performed only when currency/exchange rate changes.
        const realUnitPrice = parseFloat(value) || 0;
        const unitPrice = realUnitPrice;

        const quantity =
          Number(row?.qty || 0);

        const convrate =
          Number(row?.baseQty || 0);

        const discount =
          Number(row?.discount || 0);

        const { rate: vatRate } =
          resolveRowVat(
            vat,
            row?.vatDec
          );

        const grossAmount =
          quantity * unitPrice;

        const afterDiscount =
          grossAmount - discount;

        const vatAmount =
          (afterDiscount * Number(vatRate || 0)) /
          100;

        const finalAmount =
          afterDiscount + vatAmount;

        updatedRow.qty = quantity;
        updatedRow.baseQty = convrate;
        updatedRow.realUnitPrice = realUnitPrice;
        updatedRow.baseAmount = unitPrice;

        updatedRow.stock =
          convrate * quantity || 0;

        updatedRow.calculatedAmount =
          afterDiscount?.toFixed(
            currencyPrecision || 3
          );

        updatedRow.discountAmount =
          afterDiscount?.toFixed(
            currencyPrecision || 3
          );

        updatedRow.vatAmount =
          vatAmount?.toFixed(
            currencyPrecision || 3
          );

        updatedRow.amount =
          finalAmount;
      }

      // =======================================================
      // VAT
      // =======================================================
      if (fieldName === "vatAmount") {
        const hasManualVatValue = value !== '' && value !== null && value !== undefined;
        const manualVatAmount = Number(value || 0);
        updatedRow.isVatManuallyEntered = hasManualVatValue;
        if (hasManualVatValue) {
          updatedRow.vatAmount = value;
          updatedRow.amount = (Number(updatedRow.calculatedAmount || 0) + manualVatAmount)
            .toFixed(currencyPrecision || 3);
        } else {
          const automaticVatAmount = Number(updatedRow.calculatedAmount || 0) * Number(updatedRow.vat || 0) / 100;
          updatedRow.vatAmount = automaticVatAmount.toFixed(currencyPrecision || 3);
          updatedRow.amount = (Number(updatedRow.calculatedAmount || 0) + automaticVatAmount)
            .toFixed(currencyPrecision || 3);
        }
      }

      if (fieldName === "vat") {
        const calculatedAmount = parseFloat(row?.calculatedAmount) || 0;

        const vatRate =
          parseFloat(value?.rate) || 0;

        const vatAmount =
          (calculatedAmount * vatRate) /
          100;

        const finalAmount =
          calculatedAmount + vatAmount;

        updatedRow.vatDec =
          value?.description || "";

        updatedRow.vat =
          vatRate;
        updatedRow.isVatManuallyEntered = false;

        updatedRow.calculatedAmount = calculatedAmount?.toFixed(currencyPrecision || 3);

        updatedRow.vatAmount =
          vatAmount?.toFixed(
            currencyPrecision || 3
          );

        updatedRow.amount =
          finalAmount?.toFixed(
            currencyPrecision || 3
          );
      }

      // =======================================================
      // CALCULATED AMOUNT
      // =======================================================
      if (fieldName === "calculatedAmount") {
        const calculatedAmount = parseFloat(value) || 0;

        const vatRate =
          Number(updatedRow?.vat || 0);

        const vatAmount =
          (calculatedAmount * vatRate) /
          100;

        const finalAmount =
          truncateAmount(
            calculatedAmount + vatAmount,
            currencyPrecision || 3
          );

        updatedRow.calculatedAmount = calculatedAmount;

        updatedRow.vatAmount =
          vatAmount;

        updatedRow.amount =
          finalAmount;
      }

      if (updatedRow.isVatManuallyEntered && !["vatAmount", "vat"].includes(fieldName)) {
        updatedRow.vatAmount = manuallyEnteredVatAmount;
        updatedRow.amount = (Number(updatedRow.calculatedAmount || 0) + Number(manuallyEnteredVatAmount || 0))
          .toFixed(currencyPrecision || 3);
      }

      return updatedRow;
    });

    // ---------------------------------------------------------
    // ONE STATE UPDATE
    // ---------------------------------------------------------
    dispatch(setRows(updatedRows));
    onRequisitionData(updatedRows);
  };
  const addNewRow = () => {
    const defaultVat = getDefaultVatOption(vat);
    const newRow = {
      // srno: '',
      _rowId: createRowId(),
      ItemNo: '',
      requisitionNo: '',
      itemDescription: '',
      branch: '',
      qty: '',
      freeQty: '',
      uom: '',
      baseQty: '',
      baseAmount: '',
      realUnitPrice: '',
      amount: '',
      stock: '',
      bol: '',
      vat: defaultVat?.rate ?? 0,
      vatDec: defaultVat?.description ?? '',
      vatAmount: 0,
      isVatManuallyEntered: false,
    };
    dispatch(addRow(newRow));
    const updatedRows = [...rows, newRow];
    onRequisitionData(updatedRows);
    dispatch(setRows(updatedRows));
  };
  const handleRemoveRow = (rowToRemove) => {
    const originalIndex = rows.findIndex((row) => row === rowToRemove);

    if (originalIndex === -1) return;

    const srnoToRemove = rows[originalIndex]?.srno;

    const updatedRows = rows
      .filter((_, i) => i !== originalIndex)
      .map((row, i) => ({
        ...row,
        srno: i + 1,
      }));

    dispatch(removeSingleRow(srnoToRemove));
    dispatch(setRows(updatedRows));
    setRows(updatedRows);
    onRequisitionData(updatedRows);
  };
  const preventNegativeSign = (e) => {
    if (e.key === '-' || e.key === '+') {
      e.preventDefault();
    }
  };
  const handleFreeQTChange = (index, value) => {
    const newQty = value || 0;
    const balQty = rows[index].balQty;
    const qty = rows[index].qty || 0;

    if (newQty < 0) {
      toast.warning('Quantity cannot be less than 0.');
      return;
    }

    setRows((prevRows) => {
      const newRows = [...prevRows];
      newRows[index].freeQty = newQty;
      return newRows;
    });
  };
  const handleOverallDiscountAmount = (e) => {

    const amount = Number(e.target.value) || 0;
    const hasItemDiscount = rows.some(row => Number(row?.discount || 0) > 0);
    const hasSameVat = rows.some(row => Number(row?.vatDec || 0) > 0);
    if (hasItemDiscount) {
      toast.warning("Clear item discounts before applying overall discount.");
      return;
    }
    if (amount > calculatedTotal) {
      toast.warning("Discount amount cannot exceed total.");
      return;
    }
    const percentage = calculatedTotal === 0 ? 0 : (amount / calculatedTotal) * 100;

    if (percentage > 100) {
      toast.warning("Discount percentage cannot exceed 100%");
      return;
    }
    const total = rows.reduce((sum, row) => sum + Number(row?.amount - row?.vatAmount || 0), 0);
    const discountAmt = (calculatedTotal * percentage) / 100;
    if (discountAmt > total) {
      toast.warning("Discount amount cannot exceed total amount");
      return;
    }
    let calculatedfinal = selectedCheck === true ? calculatedTotal : total
    let afterdiscount = (calculatedTotal - discountAmt)
    let vatAmt = 0;

    if (rows.some((row) => row?.isVatManuallyEntered === true)) {
      vatAmt = rows.reduce((sum, row) => sum + Number(row?.vatAmount || 0), 0);
    } else if (rows.length === 1) {
      vatAmt = (afterdiscount * Number(rows[0]?.vat || 0)) / 100;
    } else {
      const uniqueVatRates = [...new Set(rows.map(r => Number(r?.vat || 0)))];

      if (uniqueVatRates.length === 1) {
        vatAmt = (afterdiscount * uniqueVatRates[0]) / 100;
      } else {
        vatAmt = rows.reduce(
          (sum, row) => sum + Number(row?.vatAmount || 0),
          0
        );
      }
    }
    const grandtotals = (afterdiscount + vatAmt)
    const grandtotalsvat = (afterdiscount + vatAmt)
    let final = percentage === 0 ? grandtotalsvat : grandtotals
    setDiscountInputType(amount === 0 ? "" : "amount");
    setDiscountAmount(discountAmt);
    setGrandTotal(final);
    setVatAmount(vatAmt)
    setOverallDiscount(percentage?.toFixed(3))
    setOverallDiscountAmount(e.target.value);
  };
  const handleOverallDiscount = (e) => {
    const percentage = Number(e.target.value) || 0;
    if (percentage > 100) {
      toast.warning("Discount percentage cannot exceed 100%");
      return;
    }
    const total = rows.reduce((sum, row) => sum + Number(row?.amount - row?.vatAmount || 0), 0);
    const discountAmt = (calculatedTotal * percentage) / 100;
    if (discountAmt > total) {
      toast.warning("Discount amount cannot exceed total amount");
      return;
    }
    let calculatedfinal = selectedCheck === true ? calculatedTotal : total
    let afterdiscount = (calculatedTotal - discountAmt)
    let vatAmt = 0;

    if (rows.some((row) => row?.isVatManuallyEntered === true)) {
      vatAmt = rows.reduce((sum, row) => sum + Number(row?.vatAmount || 0), 0);
    } else if (rows.length === 1) {
      vatAmt = (afterdiscount * Number(rows[0]?.vat || 0)) / 100;
    } else {
      const uniqueVatRates = [...new Set(rows.map(r => Number(r?.vat || 0)))];

      if (uniqueVatRates.length === 1) {
        vatAmt = (afterdiscount * uniqueVatRates[0]) / 100;
      } else {
        vatAmt = rows.reduce(
          (sum, row) => sum + Number(row?.vatAmount || 0),
          0
        );
      }
    }
    const grandtotals = (afterdiscount + vatAmt)
    const grandtotalsvat = (afterdiscount + vatAmt)
    let final = percentage === 0 ? grandtotalsvat : grandtotals
    setDiscountInputType(percentage === 0 ? "" : "percentage");
    setDiscountAmount(discountAmt);
    setGrandTotal(final);
    setVatAmount(vatAmt)
    setOverallDiscount(percentage)
    setOverallDiscountAmount(discountAmt);
  };
  const startResize = (e, column) => {
    e.preventDefault();

    const startX = e.clientX;
    const startWidth = columnWidths[column];

    const handleMouseMove = (event) => {
      const newWidth = Math.max(
        50,
        startWidth + (event.clientX - startX)
      );

      setColumnWidths(prev => ({
        ...prev,
        [column]: newWidth
      }));
    };

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };
  const handleQtyKeyDown = (e, rowId) => {
    if (e.key === "-" || e.key === "+") {
      e.preventDefault();
      return;
    }

    const sortedRows = [...rows].sort(
      (a, b) =>
        Number(a.srno) - Number(b.srno)
    );

    const currentIndex = sortedRows.findIndex(
      (row) => row?._rowId === rowId
    );

    if (currentIndex === -1) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();

      const nextRow =
        sortedRows[currentIndex + 1];

      if (nextRow?._rowId) {
        const nextInput = document.getElementById(
          `qty-${nextRow._rowId}`
        );

        if (nextInput) {
          nextInput.focus();
          nextInput.select();
        }
      }
    }

    if (e.key === "ArrowUp") {
      e.preventDefault();

      const previousRow =
        sortedRows[currentIndex - 1];

      if (previousRow?._rowId) {
        const previousInput =
          document.getElementById(
            `qty-${previousRow._rowId}`
          );

        if (previousInput) {
          previousInput.focus();
          previousInput.select();
        }
      }
    }
  };
  const truncateAmount = (value, decimals = 3) => {
    const num = Number(value) || 0;
    const factor = Math.pow(10, decimals);

    return Math.trunc(num * factor) / factor;
  };
  return (
    <div>
      <div className="row mb-3">
        <div className="col-md-4">
          <label>Discount %</label>
          <input
            type="number"
            className="form-control"
            onKeyDown={preventNegativeSign}
            // disabled
            value={overallDiscount}
            onChange={handleOverallDiscount}
            disabled={
              rows.some(
                x => Number(x?.discount) > 0
              )
            }
          />
        </div>
        <div className="col-md-4">
          <label>Discount Amount</label>
          <input
            type="number"
            className="form-control"
            value={overallDiscountAmount}
            onKeyDown={preventNegativeSign}
            // disabled
            onChange={handleOverallDiscountAmount}
            disabled={
              rows.some(
                x => Number(x?.discount) > 0
              )
            }
          />
        </div>
      </div>
      <div className="table-container p-2 mb-5" style={{ overflowX: 'auto', height: '400px' }}>
        {itemData ? (
          <>
            {loder === true ? (
              <div className="center p-5">
                <BarLoader color="#6E5199" size={50} height={3} width={300} />
              </div>
            ) : (
              <table>
                <thead className="dynoTable">
                  <tr>
                    <ResizableHeader column="remove">
                      <span></span>
                    </ResizableHeader>

                    <ResizableHeader column="srNo">
                      Sr no
                    </ResizableHeader>

                    <ResizableHeader column="itemNo">
                      Item No
                    </ResizableHeader>

                    <ResizableHeader column="description">
                      Description
                    </ResizableHeader>

                    <ResizableHeader column="specification">
                      Item Specs
                    </ResizableHeader>

                    <ResizableHeader column="qty">
                      Qty
                    </ResizableHeader>

                    <ResizableHeader column="unitPrice">
                      Unit Price
                    </ResizableHeader>

                    <ResizableHeader column="discount">
                      Discount
                    </ResizableHeader>

                    <ResizableHeader column="calculatedAmount">
                      Calculated Amount
                    </ResizableHeader>

                    <ResizableHeader column="vat">
                      VAT %
                    </ResizableHeader>

                    <ResizableHeader column="vatAmount">
                      VAT Amount
                    </ResizableHeader>

                    <ResizableHeader column="amount">
                      Amount
                    </ResizableHeader>

                    <ResizableHeader column="inventoryQty">
                      Inventory Qty
                    </ResizableHeader>

                    <ResizableHeader column="lastPurchasePrice">
                      Last Purchase Price
                    </ResizableHeader>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(rows) &&
                    [...rows]
                      .sort((a, b) => Number(a.srno) - Number(b.srno))
                      .map((row, index) => (
                        <tr key={row?._rowId}>

                          {/* Remove */}
                          <td
                            className="m-0 p-0"
                            style={{
                              width: `${columnWidths.remove}px`,
                              minWidth: `${columnWidths.remove}px`,
                              border: "1px solid rgba(118, 118, 118, 0.3)"
                            }}
                          >
                            <div
                              className="center"
                              onClick={() => handleRemoveRow(row)}
                            >
                              <RxCross1 size={15} />
                            </div>
                          </td>

                          {/* Sr No */}
                          <td
                            className="m-0 p-0"
                            style={{
                              width: `${columnWidths.srNo}px`,
                              minWidth: `${columnWidths.srNo}px`
                            }}
                          >
                            <input
                              className="p-2"
                              type="text"
                              value={row?.srno}
                              disabled
                              style={{
                                width: "100%",
                                boxSizing: "border-box"
                              }}
                            />
                          </td>

                          {/* Item No */}
                          <td
                            className="m-0 p-0"
                            style={{
                              width: `${columnWidths.itemNo}px`,
                              minWidth: `${columnWidths.itemNo}px`
                            }}
                          >
                            {itemData?.pOrderNo === itemData?.requisitionNo ? (
                              <AsyncSelect
                                cacheOptions
                                value={{
                                  value: row?.ItemNo,
                                  label: row?.ItemNo
                                }}
                                options={itemOptions}
                                isDisabled={
                                  itemData?.eye === true
                                }
                                loadOptions={loadOptions}
                                onChange={(selectedOption) =>
                                  handleInputChange(
                                    row?._rowId,
                                    "ItemNo",
                                    selectedOption?.label
                                  )
                                }
                                defaultOptions={itemOptions}
                                onMenuScrollToBottom={loadMoreOptions}
                                styles={{
                                  ...poCompactSelectStyles("itemNo"),
                                  control: (base) => ({
                                    ...base,
                                    width: "100%",
                                    minWidth: 0
                                  })
                                }}
                                menuPortalTarget={document.body}
                                noOptionsMessage={({ inputValue }) =>
                                  inputValue.length < 3
                                    ? "Type at least 3 characters..."
                                    : "No records found"
                                }
                              />
                            ) : (
                              <input
                                className="p-2"
                                disabled
                                value={row?.ItemNo}
                                style={{
                                  width: "100%",
                                  boxSizing: "border-box"
                                }}
                              />
                            )}
                          </td>

                          {/* Description */}
                          <td
                            className="m-0 p-0"
                            style={{
                              width: `${columnWidths.description}px`,
                              minWidth: `${columnWidths.description}px`
                            }}
                          >
                            {itemData?.pOrderNo === itemData?.requisitionNo ? (
                              // <Tooltip text={row.itemDescription}>
                              <AsyncSelect
                                cacheOptions
                                value={{
                                  value: row?.itemDescription,
                                  label: row?.itemDescription
                                }}
                                options={descriptionOptions}
                                isDisabled={
                                  itemData?.eye === true
                                }
                                loadOptions={loadDescOptions}
                                onChange={(selectedOption) =>
                                  handleInputChange(
                                    row?._rowId,
                                    "itemDescription",
                                    selectedOption?.label
                                  )
                                }
                                defaultOptions={descriptionOptions}
                                onMenuScrollToBottom={loadMoreDescOptions}
                                styles={{
                                  ...poCompactSelectStyles("itemNo"),
                                  control: (base) => ({
                                    ...base,
                                    width: "100%",
                                    minWidth: 0
                                  })
                                }}
                                menuPortalTarget={document.body}
                                noOptionsMessage={({ inputValue }) =>
                                  inputValue.length < 3
                                    ? "Type at least 3 characters..."
                                    : "No records found"
                                }
                              />
                              // </Tooltip>
                            ) : (
                              <input
                                className="p-2"
                                disabled
                                value={row?.itemDescription}
                                style={{
                                  width: "100%",
                                  boxSizing: "border-box"
                                }}
                              />
                            )}
                          </td>

                          {/* Specification */}
                          <td
                            className="m-0 p-0"
                            style={{
                              width: `${columnWidths.specification}px`,
                              minWidth: `${columnWidths.specification}px`
                            }}
                          >
                            <textarea
                              className="p-1"
                              rows="1"
                              type='text'
                              value={row?.specification}
                              onChange={(e) =>
                                handleInputChange(
                                  row?._rowId,
                                  "specification",
                                  e.target.value
                                )
                              }
                              style={{
                                width: "100%",
                                boxSizing: "border-box",
                                resize: "none"
                              }}
                            />
                          </td>

                          {/* Qty */}
                          <td
                            className="m-0 p-0"
                            style={{
                              width: `${columnWidths.qty}px`,
                              minWidth: `${columnWidths.qty}px`
                            }}
                          >
                            <input
                              className="p-2"
                              disabled={
                                itemData?.pOrderNo !==
                                itemData?.requisitionNo
                              }
                              onWheel={(e) => e.target.blur()}
                              type="number"
                              value={row?.qty}
                              onChange={(e) =>
                                handleInputChange(
                                  row?._rowId,
                                  "qty",
                                  // id: `qty-${index}`,
                                  e.target.value
                                )
                              }
                              onKeyDown={(e) =>
                                handleQtyKeyDown(row?._rowId, e.target.value)
                              }
                              id={`qty-${row?._rowId}`}

                              style={{
                                width: '100%',
                                boxSizing: "border-box"
                              }}
                            />
                          </td>

                          {/* Unit Price */}
                          <td
                            className="m-0 p-0"
                            style={{
                              width: `${columnWidths.unitPrice}px`,
                              minWidth: `${columnWidths.unitPrice}px`
                            }}
                          >
                            <input
                              className="p-2"
                              disabled={
                                itemData?.pOrderNo !==
                                itemData?.requisitionNo
                              }
                              onWheel={(e) => e.target.blur()}
                              type="number"
                              value={row?.baseAmount}
                              onChange={(e) =>
                                handleInputChange(
                                  row?._rowId,
                                  "baseAmount",
                                  e.target.value
                                )
                              }
                              onKeyDown={preventNegativeSign}
                              style={{
                                width: "100%",
                                boxSizing: "border-box"
                              }}
                            />
                          </td>

                          {/* Discount */}
                          <td
                            className="m-0 p-0"
                            style={{
                              width: `${columnWidths.discount}px`,
                              minWidth: `${columnWidths.discount}px`
                            }}
                          >
                            <input
                              className="p-2"
                              onChange={(e) =>
                                handleInputChange(
                                  row?._rowId,
                                  "discount",
                                  e.target.value
                                )
                              }
                              onKeyDown={preventNegativeSign}
                              type="number"
                              disabled={overallDiscount > 0}
                              value={row?.discount}
                              style={{
                                width: "100%",
                                boxSizing: "border-box"
                              }}
                            />
                          </td>

                          {/* Calculated Amount */}
                          <td
                            className="m-0 p-0"
                            style={{
                              width: `${columnWidths.calculatedAmount}px`,
                              minWidth: `${columnWidths.calculatedAmount}px`
                            }}
                          >
                            <input
                              className="p-2"
                              type="number"
                              onWheel={(e) => e.target.blur()}
                              onKeyDown={preventNegativeSign}
                              value={row?.calculatedAmount ?? ""}
                              onChange={(e) =>
                                handleInputChange(
                                  row?._rowId,
                                  "calculatedAmount",
                                  e.target.value
                                )
                              }
                              style={{
                                width: "100%",
                                boxSizing: "border-box"
                              }}
                            />
                          </td>

                          {/* VAT % */}
                          <td
                            className="m-0 p-0"
                            style={{
                              width: `${columnWidths.vat}px`,
                              minWidth: `${columnWidths.vat}px`
                            }}
                          >
                            <Select
                              className="flex-grow-1"
                              value={getVatSelectValue(row, vat)}
                              options={mapVatSelectOptions(vat)}
                              onChange={(selectedOption) =>
                                handleInputChange(
                                  row?._rowId,
                                  "vat",
                                  selectedOption?.value
                                )
                              }
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  width: "100%",
                                  minWidth: 0
                                })
                              }}
                            />
                          </td>

                          {/* VAT Amount */}
                          <td
                            className="m-0 p-0"
                            style={{
                              width: `${columnWidths.vatAmount}px`,
                              minWidth: `${columnWidths.vatAmount}px`
                            }}
                          >
                            <input
                              className="p-2"
                              type="text"
                              value={row?.vatAmount ?? ""}
                              onKeyDown={preventNegativeSign}

                              onChange={(e) => handleInputChange(row?._rowId, "vatAmount", e.target.value)}
                              style={{
                                width: "100%",
                                boxSizing: "border-box"
                              }}
                            />
                          </td>

                          {/* Amount */}
                          <td
                            className="m-0 p-0"
                            style={{
                              width: `${columnWidths.amount}px`,
                              minWidth: `${columnWidths.amount}px`
                            }}
                          >
                            <input
                              className="p-2"
                              disabled
                              type="text"
                              value={
                                Number(row?.amount || 0).toFixed(
                                  currencyPrecision || 3
                                )
                              }
                              style={{
                                width: "100%",
                                boxSizing: "border-box"
                              }}
                            />
                          </td>

                          {/* Inventory Qty */}
                          <td
                            className="m-0 p-0"
                            style={{
                              width: `${columnWidths.inventoryQty}px`,
                              minWidth: `${columnWidths.inventoryQty}px`
                            }}
                          >
                            <input
                              className="p-2"
                              disabled
                              type="text"
                              value={row?.stock || 0}
                              style={{
                                width: "100%",
                                boxSizing: "border-box"
                              }}
                            />
                          </td>

                          {/* Last Purchase Price */}
                          <td
                            className="m-0 p-0"
                            style={{
                              width: `${columnWidths.lastPurchasePrice}px`,
                              minWidth: `${columnWidths.lastPurchasePrice}px`
                            }}
                          >
                            <input
                              className="p-2"
                              disabled
                              type="text"
                              value={row?.avgPrice || 0}
                              style={{
                                width: "100%",
                                boxSizing: "border-box"
                              }}
                            />
                          </td>

                        </tr>
                      ))}
                </tbody>
              </table>
            )}
          </>
        ) : (
          <table>
            <thead className="dynoTable">
              <tr>
                <ResizableHeader column="remove">
                  <span></span>
                </ResizableHeader>

                <ResizableHeader column="srNo">
                  Sr no
                </ResizableHeader>

                <ResizableHeader column="itemNo">
                  Item No
                </ResizableHeader>

                <ResizableHeader column="description">
                  Description
                </ResizableHeader>

                <ResizableHeader column="specification">
                  Item Specs
                </ResizableHeader>

                <ResizableHeader column="qty">
                  Qty
                </ResizableHeader>

                <ResizableHeader column="unitPrice">
                  Unit Price
                </ResizableHeader>

                <ResizableHeader column="discount">
                  Discount
                </ResizableHeader>

                <ResizableHeader column="calculatedAmount">
                  Calculated Amount
                </ResizableHeader>

                <ResizableHeader column="vat">
                  VAT %
                </ResizableHeader>

                <ResizableHeader column="vatAmount">
                  VAT Amount
                </ResizableHeader>

                <ResizableHeader column="amount">
                  Amount
                </ResizableHeader>

                <ResizableHeader column="inventoryQty">
                  Inventory Qty
                </ResizableHeader>

                <ResizableHeader column="lastPurchasePrice">
                  Last Purchase Price
                </ResizableHeader>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(rows) &&
                rows
                  .map((row, index) => ({
                    row,
                    index
                  }))
                  .sort((a, b) => Number(a.row.srno) - Number(b.row.srno))
                  .map(({ row, index }) => (

                    <tr key={row?._rowId}>

                      {/* Remove */}
                      <td
                        className="m-0 p-0"
                        style={{
                          width: `${columnWidths.remove}px`,
                          minWidth: `${columnWidths.remove}px`,
                          border: "1px solid rgba(118, 118, 118, 0.3)"
                        }}
                      >
                        <div
                          onClick={() => handleRemoveRow(row)}
                          className="center"
                        >
                          <RxCross1 size={15} />
                        </div>
                      </td>

                      {/* Sr No */}
                      <td
                        className="m-0 p-0"
                        style={{
                          width: `${columnWidths.srNo}px`,
                          minWidth: `${columnWidths.srNo}px`
                        }}
                      >
                        <input
                          className="p-2"
                          type="text"
                          value={row?.srno || index + 1}
                          disabled
                          style={{
                            width: "100%",
                            boxSizing: "border-box"
                          }}
                        />
                      </td>

                      {/* Item No */}
                      <td
                        className="m-0 p-0"
                        style={{
                          width: `${columnWidths.itemNo}px`,
                          minWidth: `${columnWidths.itemNo}px`
                        }}
                      >
                        <AsyncSelect
                          cacheOptions
                          value={{
                            value: row?.ItemNo,
                            label: row?.ItemNo
                          }}
                          options={itemOptions}
                          loadOptions={loadOptions}
                          onChange={(selectedOption) =>
                            handleInputChange(
                              row?._rowId,
                              "ItemNo",
                              selectedOption?.label
                            )
                          }
                          defaultOptions={itemOptions}
                          onMenuScrollToBottom={loadMoreOptions}
                          styles={{
                            ...poCompactSelectStyles("itemNo"),
                            control: (base) => ({
                              ...base,
                              width: "100%",
                              minWidth: 0
                            })
                          }}
                          menuPortalTarget={document.body}
                          noOptionsMessage={({ inputValue }) =>
                            inputValue.length < 3
                              ? "Type at least 3 characters..."
                              : "No records found"
                          }
                        />
                      </td>

                      {/* Description */}
                      <td
                        className="m-0 p-0"
                        style={{
                          width: `${columnWidths.description}px`,
                          minWidth: `${columnWidths.description}px`
                        }}
                      >
                        {/* <Tooltip text={row.itemDescription}> */}
                        <AsyncSelect
                          cacheOptions
                          value={{
                            value: row?.itemDescription,
                            label: row?.itemDescription
                          }}
                          options={descriptionOptions}
                          loadOptions={loadDescOptions}
                          onChange={(selectedOption) =>
                            handleInputChange(
                              row?._rowId,
                              "itemDescription",
                              selectedOption?.label
                            )
                          }
                          defaultOptions={descriptionOptions}
                          onMenuScrollToBottom={
                            loadMoreDescOptions
                          }
                          styles={{
                            ...poCompactSelectStyles("itemNo"),
                            control: (base) => ({
                              ...base,
                              width: "100%",
                              minWidth: 0
                            })
                          }}
                          menuPortalTarget={document.body}
                          noOptionsMessage={({ inputValue }) =>
                            inputValue.length < 3
                              ? "Type at least 3 characters..."
                              : "No records found"
                          }
                        />
                        {/* </Tooltip> */}
                      </td>

                      {/* Specification */}
                      <td
                        className="m-0 p-0"
                        style={{
                          width: `${columnWidths.specification}px`,
                          minWidth: `${columnWidths.specification}px`
                        }}
                      >
                        <textarea
                          className="p-1"
                          rows="1"
                          value={row?.specification ?? ""}
                          onChange={(e) =>
                            handleInputChange(
                              row?._rowId,
                              "specification",
                              e.target.value
                            )
                          }
                          style={{
                            width: "100%",
                            boxSizing: "border-box",
                            resize: "none"
                          }}
                        />
                      </td>

                      {/* Qty */}
                      <td
                        className="m-0 p-0"
                        style={{
                          width: `${columnWidths.qty}px`,
                          minWidth: `${columnWidths.qty}px`
                        }}
                      >
                        <input
                          id={`qty-${row?._rowId}`}
                          className="p-2"
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          onKeyDown={(e) =>
                            handleQtyKeyDown(row?._rowId, e.target.value)
                          }
                          value={row?.qty}
                          onChange={(e) =>
                            handleInputChange(
                              row?._rowId,
                              "qty",
                              e.target.value
                            )
                          }
                          style={{
                            width: "100%",
                            boxSizing: "border-box"
                          }}
                        />
                      </td>

                      {/* Unit Price */}
                      <td
                        className="m-0 p-0"
                        style={{
                          width: `${columnWidths.unitPrice}px`,
                          minWidth: `${columnWidths.unitPrice}px`
                        }}
                      >
                        <input
                          className="p-2"
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          onKeyDown={preventNegativeSign}
                          value={row?.baseAmount}
                          onChange={(e) =>
                            handleInputChange(
                              row?._rowId,
                              "baseAmount",
                              e.target.value
                            )
                          }
                          style={{
                            width: "100%",
                            boxSizing: "border-box"
                          }}

                        />
                      </td>

                      {/* Discount */}
                      <td
                        className="m-0 p-0"
                        style={{
                          width: `${columnWidths.discount}px`,
                          minWidth: `${columnWidths.discount}px`
                        }}
                      >
                        <input
                          className="p-2"
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          onKeyDown={preventNegativeSign}
                          value={row?.discount}
                          onChange={(e) =>
                            handleInputChange(
                              row?._rowId,
                              "discount",
                              e.target.value
                            )
                          }
                          style={{
                            width: "100%",
                            boxSizing: "border-box"
                          }}
                        />
                      </td>

                      {/* Calculated Amount */}
                      <td
                        className="m-0 p-0"
                        style={{
                          width: `${columnWidths.calculatedAmount}px`,
                          minWidth: `${columnWidths.calculatedAmount}px`
                        }}
                      >
                        <input
                          className="p-2"
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          onKeyDown={preventNegativeSign}
                          value={row?.calculatedAmount ?? ""}
                          onChange={(e) =>
                            handleInputChange(
                              row?._rowId,
                              "calculatedAmount",
                              e.target.value
                            )
                          }
                          style={{
                            width: "100%",
                            boxSizing: "border-box"
                          }}
                        />
                      </td>

                      {/* VAT % */}
                      <td
                        className="m-0 p-0"
                        style={{
                          width: `${columnWidths.vat}px`,
                          minWidth: `${columnWidths.vat}px`
                        }}
                      >
                        <Select
                          className="flex-grow-1"
                          theme={(theme) => ({
                            ...theme,
                            padding: 10
                          })}
                          value={getVatSelectValue(row, vat)}
                          options={mapVatSelectOptions(vat)}
                          onChange={(selectedOption) =>
                            handleInputChange(
                              row?._rowId,
                              "vat",
                              selectedOption?.value
                            )
                          }
                          styles={{
                            container: (base) => ({
                              ...base,
                              width: "100%"
                            }),
                            control: (base) => ({
                              ...base,
                              width: "100%",
                              minWidth: 0
                            })
                          }}
                        />
                      </td>

                      {/* VAT Amount */}
                      <td
                        className="m-0 p-0"
                        style={{
                          width: `${columnWidths.vatAmount}px`,
                          minWidth: `${columnWidths.vatAmount}px`
                        }}
                      >
                        <input
                          className="p-2"
                          type="text"
                          value={row?.vatAmount ?? ""}
                          onKeyDown={preventNegativeSign}

                          onChange={(e) => handleInputChange(row?._rowId, "vatAmount", e.target.value)}
                          style={{
                            width: "100%",
                            boxSizing: "border-box"
                          }}
                        />
                      </td>

                      {/* Amount */}
                      <td
                        className="m-0 p-0"
                        style={{
                          width: `${columnWidths.amount}px`,
                          minWidth: `${columnWidths.amount}px`
                        }}
                      >
                        <input
                          className="p-2"
                          disabled
                          type="text"
                          value={Number(
                            row?.amount || 0
                          ).toFixed(currencyPrecision || 0)}
                          style={{
                            width: "100%",
                            boxSizing: "border-box"
                          }}
                        />
                      </td>

                      {/* Inventory Qty */}
                      <td
                        className="m-0 p-0"
                        style={{
                          width: `${columnWidths.inventoryQty}px`,
                          minWidth: `${columnWidths.inventoryQty}px`
                        }}
                      >
                        <input
                          className="p-2"
                          disabled
                          type="text"
                          value={row?.stock || 0}
                          style={{
                            width: "100%",
                            boxSizing: "border-box"
                          }}
                        />
                      </td>

                      {/* Last Purchase Price */}
                      <td
                        className="m-0 p-0"
                        style={{
                          width: `${columnWidths.lastPurchasePrice}px`,
                          minWidth: `${columnWidths.lastPurchasePrice}px`
                        }}
                      >
                        <input
                          className="p-2"
                          disabled
                          type="text"
                          value={row?.avgPrice || 0}
                          style={{
                            width: "100%",
                            boxSizing: "border-box"
                          }}
                        />
                      </td>

                    </tr>
                  ))}
            </tbody>
          </table>
        )}
        {itemData ? (
          <>
            {itemData?.eye === false ? (
              <>
                {' '}
                {itemData?.pOrderNo === itemData?.requisitionNo ? (
                  <div className="d-flex gap-5">
                    <button className="mainbtn  mt-4 gap-3" onClick={addNewRow}>
                      <div>Add</div> <IoAddSharp color="#fff" className="center mt-1 mx-2" />{' '}
                    </button>
                  </div>
                ) : (
                  ''
                )}
              </>
            ) : (
              ' '
            )}
          </>
        ) : (
          <div className="d-flex gap-5">
            <button className="mainbtn  mt-4 gap-3" onClick={addNewRow}>
              <div>Add</div> <IoAddSharp color="#fff" className="center mt-1 mx-2" />{' '}
            </button>
          </div>
        )}
      </div>
      <div className="d-flex justify-content-between boxs">
        <div className="d-flex gap-2">
          <div className="totalhead center">Total Amount</div>
          <div className="field">{parseFloat(calculatedTotal)?.toFixed(currencyPrecision || 3) || '---'}</div>
        </div>
        <div>
          <div className="totalhead center">_</div>
        </div>
        <div className="d-flex gap-2">
          <div className="totalhead center">Total Discount</div>
          <div className="field">{Number(discountAmount).toFixed(currencyPrecision || 3)}</div>
        </div>
        <div>
          <div className="totalhead center">=</div>
        </div>
        <div className="d-flex gap-2">
          <div className="totalhead center">After Discount</div>
          <div className="field">{(calculatedTotal - discountAmount).toFixed(currencyPrecision || 3)}</div>
        </div>
        <div>
          <div className="totalhead center">+</div>
        </div>
        <div className="d-flex gap-2">
          <div className="totalhead center">Total Vat</div>
          <div className="field">{parseFloat(vatAmount)?.toFixed(currencyPrecision || 3) || '---'}</div>
        </div>
        <div>
          <div className="totalhead center">=</div>
        </div>
        <div className="d-flex gap-2">
          <div className="totalhead center">Net Amount</div>
          <div className="field">{parseFloat(grandTotal)?.toFixed(currencyPrecision) || '---'}</div>
        </div>
      </div>
    </div>
  );
};

export default ItemGridTwo;